{
  "reminder": {
    "overdue": "No se ha impreso ningún punto de control del registro de auditoría en las últimas 24 horas. Imprima uno y archívelo: permite demostrar después que el registro no se ha modificado.",
    "never": "No se ha impreso ningún punto de control del registro de auditoría en este equipo. Imprima uno y archívelo: permite demostrar después que el registro no se ha modificado.",
    "last": "Último punto de control del registro de auditoría: {printedAt}.",
    "print": "Imprimir punto de control"
  },
  "sheet": {
    "title": "Punto de control del registro de auditoría",
    "explanation": "Esta hoja indica una fila del registro de auditoría y su suma de verificación. Archívela fuera del equipo. Si el registro se modificara después, la suma de verificación dejaría de coincidir, y el comando de abajo lo demuestra.",
    "seq": "Número de secuencia",
    "hash": "Suma de verificación",
    "fingerprint": "Huella",
    "anchoredAt": "Fila escrita",
    "printedAt": "Hoja impresa",
    "commandHeading": "Comprobación con esta hoja",
    "commandExplanation": "Lo ejecuta el técnico en el equipo. Ambos valores ya están rellenados y no deben modificarse.",
    "fingerprintNote": "La huella son los primeros caracteres de la suma de verificación, para compararla a simple vista. Lo que cuenta es la suma de verificación.",
    "notVerified": "Esta hoja no es una comprobación del registro. Es un punto fijo del que parte una comprobación posterior.",
    "failed": "No se pudo obtener el punto de control. Inténtelo de nuevo.",
    "retry": "Intentar de nuevo",
    "intro": "La hoja se genera e imprime al pulsar el botón. Solo entonces cuenta como impresa: si vuelve atrás antes, no se escribe nada en el registro.",
    "produce": "Imprimir punto de control",
    "producing": "Generando el punto de control …",
    "back": "Volver a la lista de la unidad"
  }
}
